/**
 * Internationalization strings for the datepicker component family.
 * Shared between Elements and React packages.
 */
export interface IDatepickerStrings {
  /** Calendar-related strings */
  calendar?: {
    /** Alt text for calendar button */
    buttonAltText?: string
  }
  /** Generic UI strings (used in range datepicker) */
  generic?: {
    /** Label for range start input */
    from?: string
    /** Label for range end input */
    to?: string
  }
  /** Form validation messages */
  forms?: {
    messages?: {
      /** Error message when date is before minimum */
      rangeUnderflow?: string
      /** Error message when date is after maximum */
      rangeOverflow?: string
      /** Error message for invalid date format */
      badInput?: string
      /** Error message when required field is empty */
      valueMissing?: string
    }
  }
  /** Date-related strings */
  dates?: {
    /** Month label */
    month?: string
    /** Year label */
    year?: string
  }
}

/**
 * Default strings for single/multiple datepicker
 */
export const defaultSingleStrings: IDatepickerStrings = {
  calendar: { buttonAltText: 'Åpne kalender' },
}

/**
 * Default strings for range datepicker
 */
export const defaultRangeStrings: IDatepickerStrings = {
  calendar: { buttonAltText: 'Åpne kalender' },
  generic: { from: 'Fra', to: 'Til' },
}
